<template>
   <span :class="classes">
      <div class="notification__text--container">
         <h5 class="notification__text">
            <slot name="title"></slot>
         </h5>
         <p class="body-1 notification__text">
            <slot name="details"></slot>
         </p>
      </div>
      <i v-if="flash" @click="closeMessage" class="fas fa-times flash-message__close js-flash-close"></i>
   </span>
</template>

<script>
export default {
   data() {
      return {
         closed: false,
         closing: false,
      }
   },
   props: {
      type: { type: String, },
      flash: { type: Boolean, default: false },
   },
   computed: {
      classes () {
            const { type, flash, closed, closing } = this

            return [
               ...(flash ? [`flash-message flash-message--${type}`] : [`notification notification--${type}`]),
               this.$tiscPlugin.theme,
               closed ? 'closed' : null,
               closing ? 'closing' : null
            ]
      },
   },
   methods: {
      closeMessage() {
         this.closing = true
         let vue = this;
         setTimeout(function () {
            vue.closing = false
            vue.closed = true
         }, 500)
      }
   },
}
</script>

<style lang="scss" scoped>
@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Elements/message.scss';
</style>